import { FilterTypes, ConditionTypesValueData, Filter } from 'app/components/filters/types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';
import { getValue } from 'app/components/filters/filters-panel/filter-types/get-value';
import { createFavouriteCondition } from 'app/components/filters/filters-panel/conditions/create-conditions';
import { createConditionValue } from './create-condition-value';
import { AdvancedSearchTypes } from 'app/types-shared';

export const userProfileConditionMapper = (
  editingValues: any,
  filterType: FilterTypes,
  getConditionTypesValueData: (advancedField: AdvancedSearchTypes) => ConditionTypesValueData
) => {
  return {
    [filterType]: (filter: Filter) => {
      const myValueFilter = getValue(filter, editingValues, customFilterFieldPostfix.userProfile);
      const myValue = myValueFilter && myValueFilter[0] && {
        periodPredef: { v: 0 },
        myValue: true
      };
      const myValueSelector = myValueFilter && myValueFilter.length > 0;

      const editingValue = editingValues && editingValues[filter.id];
      const value = editingValue && editingValue.value;
      const conditionValue = createConditionValue(1, filter, value) || [];

      if (myValueSelector) {
        const maxId = conditionValue && conditionValue.length ? Math.max(...conditionValue.map(c => c.id)) : 0;

        const favouriteConditionValue = filter.advancedField && {
          id: maxId + 1,
          code: undefined,
          ...myValue,
          ...getConditionTypesValueData(filter.advancedField)
        };
        
        conditionValue.push(favouriteConditionValue);
      }

      const originalCondition = filter && filter.conditions && filter.conditions[0];
      return conditionValue && conditionValue.length ? 
        [createFavouriteCondition(filter, conditionValue, originalCondition)] : 
        [];
    }
  };
};
